export type Utterance = {
  utterance: string
  attendeeId: string
  timestamp: string
}

export type Transcript = Utterance[]

export const mergeConsecutiveUtterances = (transcript: Transcript): Transcript => {
  if (!transcript || transcript.length === 0) return transcript

  const merged: Transcript = []
  let currentGroup: Utterance | null = null

  for (const utterance of transcript) {
    if (currentGroup && currentGroup.attendeeId === utterance.attendeeId) {
      // Merge consecutive utterances from the same attendee
      currentGroup.utterance += ' ' + utterance.utterance
    } else {
      // Different attendee or first utterance
      if (currentGroup) {
        merged.push(currentGroup)
      }
      currentGroup = { ...utterance }
    }
  }

  // Don't forget to add the last group
  if (currentGroup) {
    merged.push(currentGroup)
  }

  return merged
}
